import { PulseBaseProvider } from '../../base-classes';
const _getInstanceUri = '/api/em/v3/appinstances';
const _updateLocationUri = '/api/em/v3/locations';
const _updateCustomSettings = '/api/em/v2/customsettings';

export class EntityManagementProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
    }

    async getAppInstance(appIstanceID, deviceData, stdParameters, verbose) {
        const uri = appIstanceID ? `${_getInstanceUri}/${appIstanceID}` : _getInstanceUri;

        const queryParams = {
            ...stdParameters,
            verbose: !!verbose
        };

        const data = JSON.stringify(deviceData);

        return await super.postData(queryParams, data, uri, true, null);
    }

    async updateUserLocation(appInstanceId, locationData, stdParameters, verbose) {

        const queryParams = {
            ...stdParameters,
            appInstanceId,
            verbose: !!verbose
        };
		
        const data = JSON.stringify(locationData);

        return await super.postData(queryParams, data, _updateLocationUri, true, null);
    }
	
    async updateCustomSettings(appInstanceId, key, value, stdParameters, verbose) {

        const queryParams = {
            ...stdParameters,
            verbose: !!verbose
        };

        const uri = appInstanceId ? `${_updateCustomSettings}/appInstanceId=${appInstanceId}/${key}` : `${_updateCustomSettings}/${key}`;
        const data = JSON.stringify(value);

        return await super.postData(queryParams, data, uri, true, null);
    }
}
